import React, { useState, useEffect, useContext, useRef } from "react";
import ServiceCalls from '../utils/serviceCalls.js';
import CommonUtils from '../utils/siteUtils';

export const OMSContext = React.createContext();
export const useOMS = () => useContext(OMSContext);

export const OMSProvider = ({
    children
}) => {

    //NEW OMS - NOT USED
    const [unreadCount, setUnreadCount] = useState(null);
    const [spaceId, setSpaceId] = useState(null);

    const [omsObj, setOmsObj] = useState({
        hasRendered: false,
        widgetProps: {},
        msgWidget: null,
        msgObserver: null,
        unreadCount: ''
    });
    const [intevalPID, setInvervalPID] = useState(null);
    const widgetCreatedRef = useRef(false);
    useEffect(() => {
        const fetchData = async () => {
            await getOMSToken();
        };
        fetchData();
    }, []);


    //MOved Decrypt to Site Utils

    const getOMSToken = async () => {
        //Get Mailbox
        if (intevalPID !== null) return;
        try {
            const tokenData = await CommonUtils.fetchOMSToken();
            //Save signin time to local session storage for token refresh logic
            var signOnTime = new Date();
            if (sessionStorage.getItem("curSignInTime") == null) {
                sessionStorage.setItem("curSignInTime", signOnTime);
            }
            else {
                signOnTime = sessionStorage.getItem("curSignInTime");
            }

            console.log(`In getOMSToken - Successfully retrieved OMS Token - Setting signon time as: ${signOnTime}`);
            const tokenProps = {
                omsToken: tokenData,
                signOnTime: signOnTime
            };
            setOmsObj({ widgetProps: tokenProps });
            setInvervalPID('99');


            await getMailbox(tokenProps);
        }
        catch (e) {
            const err = `Error in OMS Context - Creating OMS Token. NO MAIL WILL BE AVAILABLE. Ex: ${e}`;
        }
    };


    const getMailbox = async (tokenProps) => {
        try {
            const data = await ServiceCalls.getOMSMailbox();
            if (data) {
                if (data.count === 0) {
                    console.log("In getMailbox - Failed to find mailbox.  Attempting to Create");
                    await createMailbox(tokenProps);
                } else {
                    const omsProps = {
                        omsToken: tokenProps,
                        mailbox: data.mailbox[0],
                        recipients: data.recipients,
                        emea_recipients: data.emea_recipients,
                        environmentUrl: data.environmentUrl,
                        environment: data.environment,
                        tokenUrl: data.tokenUrl,
                        checkMailInterval: data.checkMailInterval
                    };
                    setOmsObj({ widgetProps: omsProps });
                    const successMsg = `Mailbox ${omsProps.mailbox.mid} for ${omsProps.mailbox.email} already exists  - Loading widget`;
                    const infoaudit = { message: successMsg, severity: 'Informational' };
                    await ServiceCalls.postAuditLog(infoaudit);
                    await createWidget(omsProps);
                }
            }
        } catch (e) {
            const err = `IN getMailbox - Getting Mailbox. NO MAIL WILL BE AVAILABLE. Ex: ${e}`;
            console.log(err);
            const excepaudit = { message: err, severity: 'Exception' };
            await ServiceCalls.postAuditLog(excepaudit);
        }
    };

    const createMailbox = async (tokenProps) => {
        try {
            const data = await ServiceCalls.createOMSMailbox();
            if (data && data.mailbox) {
                console.log(`In CreateMailbox - Created mailbox data ${JSON.stringify(data)}`);

                const omsProps = {
                    omsToken: tokenProps,
                    mailbox: data.mailbox[0],
                    recipients: data.recipients,
                    emea_recipients: data.emea_recipients,
                    environmentUrl: data.environmentUrl,
                    environment: data.environment,
                    tokenUrl: data.tokenUrl,
                    checkMailInterval: data.checkMailInterval
                };

                setOmsObj({
                    widgetProps: omsProps
                });

                const Widgetaudit = {
                    message: `Mailbox ${omsProps.mailbox.mid} created for ${omsProps.mailbox.email} - Not loading widget`,
                    severity: 'Informational'
                };
                await ServiceCalls.postAuditLog(Widgetaudit);

                // If you want to load the widget after mailbox creation, uncomment:
                // await createWidget(omsProps);
            }
        } catch (e) {
            const err = `In CreateMailbox - Creating Mailbox. NO MAIL WILL BE AVAILABLE. Ex: ${e}`;
            console.log(err);
            const exceptaudit = {
                message: err,
                severity: 'Exception'
            };
            await ServiceCalls.postAuditLog(exceptaudit);
        }
    };


    const createWidget = async (widgetProps) => {
        let unreadCount = 0;

        try {

            console.log(`In createWidget - Widget does not exist for mailbox ${widgetProps.mailbox.mid} and Email ${widgetProps.mailbox.email} - Creating`);
            console.log('In createWidget - After Initialization');
            setOmsObj({
                widgetProps: widgetProps,
                hasRendered: true,
                msgWidget: null,
                unreadCount: 0
            });


        } catch (e) {
            var err = `In createWidget - ERROR Initializing Widget. NO MAIL WILL BE AVAILABLE. Ex: ${e}`;
            console.log(err);
            var data = {
                message: err,
                severity: 'Exception'
            };
            try {
                await ServiceCalls.postAuditLog(data);
            } catch (err2) {
                console.log('In createWidget - Failed to post audit log:', err2);
            }
        }
    };

    const refreshWidget = async () => {
        await getOMSToken();
    };

    const disposeWidget = async () => {
        //if (omsObj.msgObserver) {
        //    await omsObj.msgObserver.unsubscribe(); // Only if unsubscribe is async
        //}
        //Remove Event Handler
        console.log('In disposeWidget - Disposing OMS Widget and removing event listeners');
        document.body.removeEventListener('unreadMessageCount');
        //  window.OptumMessenger._widgetInstance = null;
        setOmsObj({});
        widgetCreatedRef.current = false;
    };

    return (
        <OMSContext.Provider
            value={{
                omsObj,
                refreshWidget,
                disposeWidget,
                unreadCount,
                spaceId
            }}
        >
            {children}
        </OMSContext.Provider>
    );
};